export const matchTextOnObject = (text = '', object, keys = []) => {
  for (const key of keys) {
    if (typeof object[key] !== 'string') {
      continue
    }

    if(object[key].match(RegExp(text, 'i'))) {
      return true
    }
  }
  return false
}

export default {
  matchTextOnObject
}